<script>
import Vue from 'vue'
import axios from 'axios'
import ApiService from '@/api/ApiService'
import { ServerTable, Event } from 'vue-tables-2'
Vue.use(ServerTable, {}, false, 'bootstrap4')

export default {
  props: {
    limit: {
      type: Number,
      required: false,
      default: null
    },
    shouldShowLimit: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  created: function () {
    if (this.limit !== null && Number.isInteger(this.limit)) {
      this.tableOptions.perPage = this.limit
      if (!this.tableOptions.perPageValues.includes(this.limit)) {
        this.tableOptions.perPageValues.push(this.limit)
        this.tableOptions.perPageValues.sort((a, b) => a - b)
      }
    }

    if (!this.shouldShowLimit) {
      this.tableOptions.perPageValues.length = 0
    }
  },
  components: {
    Event
  },
  data: function () {
    return {
      cancelationCallback: null,
      showQueryResetIcon: false,
      tableOptions: {
        columnsDropdown: true,
        debounce: 750,
        pagination: {
          chunk: 5,
          nav: 'scroll',
          edge: true
        },
        requestFunction: (data) => {
          const page = data.page
          return new Promise((resolve, reject) => {
            if (this.cancelationCallback !== null) {
              this.cancelationCallback()
            }
            ApiService.cancelableQuery(this.queryUrl, data, new axios.CancelToken(c => {
              this.cancelationCallback = c
            }), this.cancelableQueryToken ? this.cancelableQueryToken : null )
              .then(response => {
                if (response.data.meta.current_page) {
                  if( this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = response.data.meta.current_page
                  }
                } else if (page) {
                  if( this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = page
                  }
                }
                resolve({
                  data: response.data.data ? response.data.data : response.data.items,
                  count: response.data.meta.total,
                  page: response.data.meta.current_page
                })
              })
              .catch(error => {
                if (!axios.isCancel(error)) {
                  reject(error)
                }
              })
          })
        },
        saveState: true,
        sortIcon: {
          is: 'sort-icon',
          base: 'sort-icon-class',
          up: 'sort-icon-up',
          down: 'sort-icon-down'
        },
        skin: 'table table-striped table-hover is-fullwidth',
        storage: 'local',
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('tables.no_records'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns_dropdown')
        },
      }
    }
  },
  methods: {
    emitTableFilter: function (event, value) {
      Event.$emit(event, value)
    },
    onFilterUpdate: function (query) {
      this.showQueryResetIcon = query.length > 0
    },
    resetQueryFilter () {
      this.showQueryResetIcon = false
      this.getTableReference().setFilter('')
    }
  }
}
</script>
